<template>
  <div v-if="!brandPriceHidden()" class="a-price" :class="className">
    <div :class="isHorizontal ? 'd-flex' : 'd-inline-block'">
      <div
        v-if="(!hideRegularPrice && !isProductOnDiscount) || (!hideRegularPrice && isProductOnDiscount && !isLavpris)"
        class="a-price__value"
        :class="{
          '-old': isProductOnDiscount,
          '-horizontal': isHorizontal,
        }">
        {{ includeVat ? price.regularFormatted : price.regularExVatFormatted }} /{{ $t("productUnit") }}
      </div>
      <div v-if="isProductOnDiscount" class="a-price__value -discount">
        {{ includeVat ? price.priceFormatted : price.priceExVatFormatted }} /{{ $t("productUnit") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Price",
  props: {
    price: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: false,
    },
    includeVat: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
    isProductOnDiscount: {
      type: Boolean,
      default: false,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    hideRegularPrice: {
      type: Boolean,
      default: false,
    },
    isLavpris: {
      type: Boolean,
      default: false,
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentCulture() {
      return this.$store.getters["site/getCurrentCulture"];
    },
    siteSettings() {
      return this.$store.getters["site/getSiteSettings"];
    }
  },
  methods: {
    getPropertyValue(propertyName) {
      let item = this.product?.properties?.find((x) => x.name.toLowerCase() === propertyName.toLowerCase() && x.value !== "");
      return item?.value;
    },
    brandPriceHidden() {
      const hiddenBrands = this.siteSettings?.hiddenBrands ?? [];
      return hiddenBrands.map((str) => str.toLowerCase()).includes(this.getPropertyValue("brand")?.toLowerCase()) && !this.isLoggedIn;
    },
  },
};
</script>
